/* eslint-disable no-magic-numbers */
export default (num) => {
    let _num = num;
    if (!parseInt(_num / 10)) {
        _num = `0${_num}`;
    }
    return _num;
};
